import { GlIcon, GlTooltipDirective } from '@gitlab/ui';
import { i18nPolicyText } from '../../constants';
export default {
    name: 'EscalationPolicyCollapsedState',
    i18n: i18nPolicyText,
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlIcon
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        policyText () {
            return this.value ? this.$options.i18n.paged : this.$options.i18n.none;
        },
        tooltipText () {
            const policyName = this.value || this.$options.i18n.none;
            return `${this.$options.i18n.title}: ${policyName}`;
        }
    }
};
